module.exports = __webpack_public_path__ + "media/images/fleche-noire-3bcea1d52fcbd76461c0cb528be441d2.png";